<template>
    <!-- Header -->
    <div class="wrapper overflow-hidden">
        <div class="position-fixed w-100 p-lg-3 p-1" style="z-index: 1200;">
            <div class="d-flex flex-wrap bg-white rounded-xl shadow border border-light">
                <div class="w-100 d-flex flex-nowrap justify-content-between align-items-center p-4"
                    style="height: 5rem;">
                    <div style="min-width: 25%;">
                        <a class="mr-5" href="/">
                            <img src="@/assets/img/logo.png" alt="6v6" title="6v6 Logo"
                                class="d-none d-lg-inline-block w-auto" style="height: 2.25rem;">
                            <img src="@/assets/img/logo.png" alt="6v6" title="6v6 Logo"
                                class="inline-block d-lg-none h-auto" style="width: 3rem;">
                        </a>
                    </div>
                    <div class="d-none d-lg-flex flex-nowrap align-items-center mx-auto">
                        <template v-if="!isLoggedIn || currentUser.role != 'player'">
                            <a class="mx-2" href="/">Accueil</a>
                            <a class="mx-2" href="/search">Réserver</a>
                            <a class="mx-2" href="/contact">Contact</a>
                        </template>
                        <template v-else>
                            <a class="mx-2" href="/">Accueil</a>
                            <a class="mx-2" href="/search">Réserver</a>
                            <a class="mx-2" href="/my/matches">Matchs</a>
                        </template>
                    </div>
                    <div class="d-flex flex-nowrap align-items-center justify-content-end" style="min-width: 25%;">
                        <span class="d-none d-lg-flex" v-if="!isLoggedIn">
                            <a class="btn d-none d-lg-inline-block mx-1 px-3 bg-light rounded-pill text-sm" style="line-height: 1.8;" href="/become-partner">
                                Devenir Partenaire
                            </a>
                            <a class="btn d-none d-lg-inline-block mx-1 px-3 btn-primary rounded-pill text-dark text-sm" style="line-height: 1.8;" href="/login">
                                Se connecter
                            </a>
                            <!-- <a class="btn d-none d-lg-inline-block mr-1 px-2 bg-light rounded-pill" href="javascript:void(0)" data-toggle="modal" data-target="#authModal">
                                <span class="material-symbols-outlined mx-0" style="min-width: 28px;">person</span>
                            </a> -->
                        </span>
                        <span class="d-flex" v-if="isLoggedIn">
                            <a class="btn d-inline-block mr-1 px-2 bg-light rounded-pill position-relative" href="javascript:void(0)" data-toggle="modal" data-target="#userMenuModal">
                                <span class="material-symbols-outlined mx-0" style="min-width: 28px;">person</span>
                                <span v-if="unread_notifications.length > 0"
                                    class="position-absolute rounded-circle bg-danger border-white" style="top: 0; right: 0; width: 10px; height: 10px;"></span>
                            </a>
                            <!-- <a class="btn d-inline-block px-2 pb-1 rounded-pill position-relative" href="javascript:void(0)" data-toggle="modal" data-target="#userMenuModal">
                                <span class="material-icons-outlined mx-0 mt-1" style="min-width: 28px;">dehaze</span>
                            </a> -->
                        </span>
                        <button type="button" id="toggle-mobile-menu" class="btn d-lg-none p-0 bg-white border-0 ml-1 mx-2">
                            <span class="icon-hamburger">
                                <span class="material-symbols-outlined mx-0 mt-1">dehaze</span>
                            </span>
                            <span class="icon-close d-none">
                                <span class="material-symbols-outlined mx-0 mt-1">close</span>
                            </span>
                        </button>
                    </div>
                </div>
                <div id="mobile-menu" class="d-none d-lg-none flex-column py-3 px-2 align-items-center w-100 border-top border-light rounded-xl bg-white">
                    <template v-if="!isLoggedIn">
                        <a class="btn d-block bg-white-hover rounded-xl text-sm text-left px-2 py-2 pl-3 mx-1" href="/"><b>Accueil</b></a>
                        <a class="btn d-block bg-white-hover rounded-xl text-sm text-left px-2 py-2 pl-3 mx-1" href="/search"><b>Réserver</b></a>
                        <a class="btn d-block bg-white-hover rounded-xl text-sm text-left px-2 py-2 pl-3 mx-1 mb-1" href="/contact"><b>Contact</b></a>
                        <a class="btn d-block bg-light rounded-xl text-xs text-center mt-2 mx-1" style="line-height: 1.8;" href="/become-partner">
                            <b>Devenir Partenaire</b>
                        </a>
                        <a class="btn d-block btn-primary rounded-xl text-xs text-center text-dark mt-1 mx-1" style="line-height: 1.8;" href="/login">
                            <b>Se connecter</b>
                        </a>
                        <!-- <a class="btn d-flex align-items-center px-2 py-2 pl-3 w-100 rounded-xl bg-white-hover text-sm font-weight-500" href="#" @click.prevent="logout" v-if="isLoggedIn">
                            <span class="material-symbols-outlined mx-0 text-lg">logout</span>
                            <span class="ml-1">Se Déconnecter</span>
                        </a>
                        <a class="btn d-flex align-items-center px-2 py-2 pl-3 w-100 rounded-xl bg-white-hover text-sm font-weight-500" href="/login" v-if="!isLoggedIn">
                            Se connecter
                        </a>
                        <a class="btn d-flex align-items-center px-2 py-2 pl-3 w-100 rounded-xl bg-white-hover text-sm font-weight-500" href="/register" v-if="!isLoggedIn">
                            S'inscrire
                        </a> -->
                    </template>
                    <template v-else>
                        <a class="btn d-block bg-white-hover rounded-xl text-sm text-left px-2 py-2 pl-3 mx-1" href="/"><b>Accueil</b></a>
                        <a class="btn d-block bg-white-hover rounded-xl text-sm text-left px-2 py-2 pl-3 mx-1" href="/search"><b>Réserver</b></a>
                        <a class="btn d-block bg-white-hover rounded-xl text-sm text-left px-2 py-2 pl-3 mx-1" href="/my/matches"><b>Matchs</b></a>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <!-- /Header -->
    
    <Teleport to="body">
        <div class="modal fade" id="authModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="d-flex flex-row justify-content-around align-items-center" style="min-height: 15vh;">
                            <div class="text-center w-100 my-3">
                                <a href="/login" class="btn bg-light rounded-pill shadow-sm">Se connecter</a>
                            </div>
                            <span>ou</span>
                            <div class="text-center w-100">
                                <a href="/register" class="btn bg-light rounded-pill shadow-sm">S'inscrire</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>

    <Teleport to="body">
        <div class="modal fade" id="userMenuModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body" id="userMenuModalBody">
                        <span class="icon-close position-absolute px-1" style="cursor: pointer; right: 1rem" data-dismiss="modal">
                            <span class="material-symbols-outlined mx-0 mt-1">close</span>
                        </span>
                        <customer-sidebar v-if="currentUser.role === 'player'"></customer-sidebar>
                        <vendor-sidebar v-else-if="currentUser"></vendor-sidebar>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped>
.material-symbols-outlined {
    line-height: 1.2 !important;
}
</style>

<script>
import _ from "lodash"
import moment from 'moment'
import 'moment/locale/fr'
import { api } from '@/store';

import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";

moment.locale('fr')

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        "vendor-sidebar": VendorSidebar,
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        notifications() {
            return this.$store.getters.notifications;
        },
        unread_notifications() {
            return this.$store.getters.notifications.filter(notification => !notification['is_read'])
        },
        showDashbord(){
            return true
        },
        currentUser() {
            return this.$store.getters.currentUser;
        },
        currentPath() {
            return this.$route.name;
        }
    },
    mounted() {
        $(document).ready(function () {
            $("#toggle-mobile-menu").on("click", function() {
                $(".icon-hamburger, .icon-close").toggleClass("d-none");
                $("#mobile-menu").toggleClass("d-none");
            });
        });
    },
    beforeUnmount() {
        // Use the appropriate jQuery selector for your modals
        // $('.modal').modal('hide');
        // Additionally, you might need to manually remove the backdrop if it persists
        // $('.modal-backdrop').remove();
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
        },
        getNotificationAge(timestamp) {
            return moment(timestamp).fromNow() // Returns relative time in French
        },
        async markAsRead(id) {
            return await api.post('/notifications/' + id + '/read')
              .then(response => {
                const result = response.data;
              });
        }
    },
}
</script>
    